import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import cn from 'classnames'

import { Icon } from 'src/components/ui'
import Modal from 'src/components/ui/Modal/Modal'
import { ParticipantUser } from 'src/pages/Bottle/Bottles.types'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import styles from './ModalDailyLottery.module.scss'

interface Props {
  className?: string
  isActiveModal: boolean
  changeActiveModal: () => void
  participant_users: ParticipantUser[]
}

const ITEMS = ['main_bottle_item.modal.item_1', 'main_bottle_item.modal.item_2', 'main_bottle_item.modal.item_3']

export const ModalDailyLottery: FC<Props> = ({ isActiveModal, changeActiveModal, participant_users }) => {
  const userId = useGlobalStore((store) => store.user)?.id

  const { t } = useTranslation()

  const userIndex = participant_users.findIndex((user) => user.user.id === userId)

  let user = { stars_amount: 0, tickets: 0 }
  if (userIndex > -1) {
    user = participant_users[userIndex]
  }

  const userStarsAmountInTickets = user?.stars_amount * 20
  const userTickets = user?.tickets
  const userTotalTickets = userStarsAmountInTickets + userTickets

  const numberAdsViewedOnHour = localStorage.getItem('numberAdsViewedOnHour')

  return isActiveModal ? (
    <Modal className={styles.modal}>
      <div className={styles.icon}>
        <button onClick={changeActiveModal}>
          <Icon name='cancel' />
        </button>
      </div>

      <div className={styles.tickets_on_balance}>
        <p>{t('main_bottle_item.modal.tickets')}</p>
        <div className={styles.number}>
          <Icon name='ticket' />
          <p>
            <span>{userTotalTickets}</span>/300
          </p>
        </div>
      </div>

      <div className={styles.main}>
        <h2>{t('main_bottle_item.modal.how_works')}</h2>

        <p className={styles.description}>{t('main_bottle_item.modal.description')}</p>

        <ul className={styles.list}>
          {ITEMS.map((el) => (
            <li key={el}>
              <Icon name='raffle_checkmark' />
              <p>{t(el)}</p>
            </li>
          ))}
        </ul>

        <div className={cn(styles.card, styles.exchange)}>
          <div className={styles.top}>
            <p>{t('main_bottle_item.modal.exchange')}</p>
            <p>{userStarsAmountInTickets}/200</p>
          </div>
          <div className={styles.progress}>
            <div style={{ width: `${(userStarsAmountInTickets / 200) * 100}%` }} />
          </div>
        </div>

        <div className={cn(styles.card, styles.tickets)}>
          <div className={styles.wrap}>
            <div className={styles.top}>
              <p>{t('main_bottle_item.modal.advertising')}</p>
              <p>{userTickets}/100</p>
            </div>
            <div className={styles.progress}>
              <div style={{ width: `${userTickets}%` }} />
            </div>
          </div>

          <div className={styles.views}>
            <p>{t('main_bottle_item.modal.views')}</p>
            <div>
              <Icon name='number_views' />
              <p>{numberAdsViewedOnHour}</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  ) : null
}
